export enum ItemType{
    StandaloneItem = 1,
    Milk = 2, //this is milk Sku into POS
    BomMilk = 3, //this is milk Sku into Recipes
}